import Vue from 'vue';
//import {preloadImage} from "../../lib/cache";

export default {
  namespaced: true,
  state: {
    list : [],
    cacheKey:'fitt',
    isCaching:false,
    cacheMinuteCeiling:20
  },
  mutations: {
    setList(state, list){
      state.list=list;
    },
    setCachingActive(state,active){
      state.isCaching=active;
    },
    setAssetCached(state,assetid){
      for(let i=0; i<state.list.length;i++){
        const item=state.list[i];
        if(item.assetid===assetid){
          item.cached=true;
          Vue.set(state.list,i,item);
          return;
        }
      }
    }
  },
  actions: {
    removeForJourneyplan({state},journeyplanid){
      const itemsToRemove=state.list.filter((item)=>item.journeyplanids.includes(journeyplanid));
      caches.open(state.cacheKey).then((cache)=>{
        for(let item of itemsToRemove){
          cache.delete(item.url);
        }
      });
    },
    async setAssetList({commit,state,dispatch},assetList){
      const cache=await caches.open(state.cacheKey);
      for(let item of assetList){
        const result = await cache.match(item.url);
        item.cached = !!result;
      }
      commit('setList',assetList);

      setTimeout(()=>{
        dispatch('cacheRelevantAssets');
      },50);
    },
    async cacheRelevantAssets({commit,state, rootGetters, rootState}){
      if(state.isCaching){
        return;
      }

      commit('setCachingActive',true);
      const cache=await caches.open(state.cacheKey);

      if(rootState.assessment.assessment && rootState.assessment.assessment.profilepic){
        //preloadImage(rootState.assessment.assessment.profilepic.url);
        const hasProfilePic=await cache.match(rootState.assessment.assessment.profilepic.url);
        if(!hasProfilePic){
          await cache.add(rootState.assessment.assessment.profilepic.url);
        }
      }

      const getPendingItem=()=>{
        const currentMinutes = rootGetters['assessment/minutesPassed'];
        for(let asset of state.list){
          if(asset.time>=(currentMinutes-10) && asset.time<=currentMinutes+state.cacheMinuteCeiling && !asset.cached){
            return asset;
          }
        }
        return null;
      };

      let i=0;
      let pendingItem=getPendingItem();
      while (pendingItem && i<1000){
        try{
          await cache.add(pendingItem.url);
        }catch (e) {
          console.error(e);
        }
        commit('setAssetCached',pendingItem.assetid);
        pendingItem=getPendingItem();
        i++;
      }
      commit('setCachingActive',false);

    }
  },
  getters: {
    dict(state){
      return state.list.keyBy('assetid');
    }
  }
}
